import type { Middleware } from 'openapi-fetch'

const transformUserIdKeys = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map(item => transformUserIdKeys(item))
  }
  
  if (typeof obj === 'object' && obj !== null) {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      const newKey = key === 'userID' ? 'userId' : key
      acc[newKey] = transformUserIdKeys(value)
      return acc
    }, {} as any)
  }
  
  return obj
}

export const responseMiddleware: Middleware = {
  async onResponse({ request, response }) {
    if (!response.ok || !request.url.includes('/api/v1/customer')) {
      return response
    }

    try {
      const data = await response.clone().json()
      
      // Convert userID to userId in the response data using a recursive function
      const transformedData = transformUserIdKeys(data)

      const modifiedResponse = Response.json(transformedData, {
        status: response.status,
        statusText: response.statusText,
        headers: Object.fromEntries(response.headers.entries())
      })

      return modifiedResponse
    } catch (error) {
      return response
    }
  }
}